import { useState } from 'react'
import eyeClosed from '../../assets/eye-closed.png'
import eye from '../../assets/eye.png'

const PasswordInput = (props) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
        <>
            <input 
                className='focus:outline-1 focus:outline-accent border-neutral5 py-2.5 pl-3 pr-10 gap-2.5 self-stretch border rounded mt-1.5 font-montserrat h-10' 
                style={{ borderColor: props.error ? '#E85F5C' : null }}
                id='password' 
                type={showPassword ? 'text' : 'password'}
                value={props.value}
                placeholder={props.placeholder}
                onChange={props.onChange} 
            />

            <img 
                className='h-[1.125rem] w-[1.125rem] self-end me-3 -mt-[1.85rem] cursor-pointer' 
                id='togglePasswordVisibility' 
                onClick={() => setShowPassword(!showPassword)} 
                src={showPassword ? eye : eyeClosed} 
                alt='Eye Icon' 
            />
        </>
    )
}

export default PasswordInput